import React from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la UI de repuesto
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes registrar el error en un servicio de reporte de errores
    console.error("Uncaught error in React Error Boundary:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    // Limpia el caché local de auth por si el crash viene de Supabase auth expirado o corrupto
    localStorage.removeItem('supabase.auth.token');
    sessionStorage.clear();
    // Forzar recarga limpia
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier interfaz de repuesto
      return (
        <div className="min-h-screen bg-[#001008] text-white flex flex-col items-center justify-center p-4">
          <div className="max-w-md w-full bg-[#001a0f] border border-[#00ff9c]/20 p-8 rounded-2xl shadow-[0_0_40px_rgba(0,255,156,0.1)] text-center">
            <AlertTriangle className="w-16 h-16 text-[#00ff9c] mx-auto mb-6 opacity-80" />
            <h1 className="text-2xl font-bold mb-4 text-[#e0e0e0]">Oops, algo salió mal.</h1>
            <p className="text-[#8aa0b4] mb-8 text-sm">
              La aplicación encontró un error inesperado al cargar la interfaz. 
              Esto suele solucionarse recargando la página y limpiando la sesión activa.
            </p>
            
            <button 
              onClick={this.handleReset}
              className="flex items-center justify-center gap-2 w-full bg-[#00ff9c] text-[#00391f] font-bold py-3 px-6 rounded-xl hover:bg-[#00ccff] transition-all shadow-[0_0_20px_rgba(0,255,156,0.3)] hover:shadow-[0_0_30px_rgba(0,204,255,0.4)]"
            >
              <RefreshCcw size={18} />
              Recargar Aplicación
            </button>
            
            {this.state.error && (
              <div className="mt-8 text-left bg-black/40 p-4 rounded-lg overflow-x-auto">
                <p className="text-xs text-red-400 font-mono break-words">
                  {this.state.error.toString()}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}
